app.service('fusionRelevanceRatingService', [
  '$ngConfirm', 'HttpAuth', 'apiHelper', 'portalHelper', 'CONSTANTS',
  function ($ngConfirm, HttpAuth, apiHelper, portalHelper, CONSTANTS) {
    this.setupScope = function ($scope) {
      $scope.payer_relevance_rating_choices = [
        CONSTANTS.payerRelevanceRatings.NO_RATING,
        CONSTANTS.payerRelevanceRatings.LOW_RELEVANCE,
        CONSTANTS.payerRelevanceRatings.ACCEPTABLE_RELEVANCE,
        CONSTANTS.payerRelevanceRatings.HIGH_RELEVANCE
      ];

      $scope.check_save_button_state = function () {
        if ($scope.initial_rating === $scope.selected_response_to_edit_relevance_rating.relevance_rating.rating) {
          $scope.edit_relevance_popup.buttons.OK.setDisabled(true);
          return;
        }
        $scope.edit_relevance_popup.buttons.OK.setDisabled(false);
      };
    };

    this.openEditDialog = function ($scope, { payerName, fusionAssignmentId, currentRating, onSuccess }) {
      $scope.selected_response_to_edit_relevance_rating = {
        payer: {
          first_name: (payerName || '').split(' ')[0],
          last_name: (payerName || '').split(' ').slice(1).join(' ')
        },
        relevance_rating: currentRating
          ? angular.copy(currentRating)
          : { rating: null }
      };

      $scope.selected_response_to_edit_relevance_rating.relevance_rating =
        portalHelper.addChangeHistoryLabel($scope.payer_relevance_rating_choices, $scope.selected_response_to_edit_relevance_rating.relevance_rating);

      $scope.initial_rating = $scope.selected_response_to_edit_relevance_rating.relevance_rating.rating;

      const API_URL = apiHelper.getApiUrl();

      $scope.edit_relevance_popup = $ngConfirm({
        title: 'Set Relevance Rating',
        contentUrl: portalHelper.getUrlRev('../html_templates/dialogs/edit_relevance_rating.66eb9309.html'),
        type: 'blue',
        closeIcon: true,
        columnClass: 'medium',
        scope: $scope,
        buttons: {
          OK: {
            text: 'Save Relevance Rating',
            btnClass: 'mat ui primary button',
            action: function (scope, button) {
              button.setText('Saving...');
              button.setDisabled(true);
              let url, method, data;

              if (scope.selected_response_to_edit_relevance_rating.relevance_rating.id) {
                url = API_URL + '/api/admin/survey/rating/submit/' + scope.selected_response_to_edit_relevance_rating.relevance_rating.id + '.json';
                method = HttpAuth.put;
                data = {
                  rating: scope.selected_response_to_edit_relevance_rating.relevance_rating.rating,
                  id: scope.selected_response_to_edit_relevance_rating.relevance_rating.id,
                  fusion_assignment: fusionAssignmentId
                };
              } else {
                url = API_URL + '/api/admin/survey/rating/submit.json';
                method = HttpAuth.post;
                data = {
                  rating: scope.selected_response_to_edit_relevance_rating.relevance_rating.rating,
                  fusion_assignment: fusionAssignmentId
                };
              }

              method(url, data)
                .then(function (result) {
                  portalHelper.showToast(CONSTANTS.typeOfToasts.SUCCESS, 'Rating updated successfully');
                  if (onSuccess) onSuccess(result.data);
                })
                .catch(function (error) {
                  portalHelper.showErrorCommon(error);
                })
                .finally(function () {
                  button.setText('Save Relevance Rating');
                  button.setDisabled(false);
                  scope.edit_relevance_popup.close();
                });

              return false;
            }
          }
        }
      });

      $scope.edit_relevance_popup.buttons.OK.setDisabled(true);
    };
  }
]);
